import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { get } from '../../helper/helper_api';

export default function BlogDetails() {
    const paramas = useParams();
    const [data, setData] = useState(undefined);
    useEffect(() => {

        if (paramas?.name)
            getData(paramas?.name)
    }, [paramas])



    const getData = (title) => {
        get(`blog/title?title=${title}`)
            .then(res => {
                if (res?.statusCode == 200) {
                    setData(res?.data)

                }
            }).catch(err => {
                console.log(err)
            })

        console.log(paramas?.name)
    }


    return (
        <>
            <section class="top-space-margin half-section pb-0">

                <div class="container">

                    <div class="row">

                        <div class="col-12">

                            <img class="border-radius-6px" src="images/demo-decor-store-title-bg.jpg" alt="" />

                        </div>

                    </div>

                </div>

            </section>
            <section class="pb-0 pt-40px">

                <div class="container">

                    <div class="row justify-content-center">

                        <div class="col-lg-10 text-center">

                            <span class="fs-18 mb-20px d-inline-block">Writer by <a href="demo-decor-store-blog.html" class="fw-600 d-inline-block align-middle text-dark-gray">{data?.authorName}</a> </span>

                            <h2 class="alt-font fw-700 text-dark-gray mx-auto w-80 xl-w-100 mb-5">{data?.title}</h2>

                            <i class="feather icon-feather-more-horizontal- icon-double-large text-light-gray d-inline-block mb-5 d-inline-block"></i>

                        </div>

                    </div>

                </div>

            </section>

            {/* <!-- end section --> */}

            {/* <!-- start section --> */}

            <section class="py-0">

                <div class="container">

                    <div class="row justify-content-center">

                        <div class="col-lg-10">

                            <div class="dropcap-style-02 last-paragraph-no-margin">

                                <p><span class="alt-font first-letter first-letter-block first-letter-round bg-dark-gray text-white">{data?.titleShort?.split('')[0]}</span>{data?.titleShort}</p>

                                <img src="images/demo-decor-store-blog-single-chair.jpg" class="mb-30px mt-6" alt="" />

                                {/* <p class="pb-25px text-center alt-font text-dark-gray ls-1px fw-600 text-uppercase">We must never confuse elegance with snobbery</p> */}

                                <div class="h-3px w-100 bg-dark-gray"></div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* <!-- end section --> */}

            {/* <!-- start section --> */}

            <section>

                <div class="container">

                    <div class="row justify-content-center">

                        <div class="col-lg-10">

                            <div class="row">

                                <div class="col-lg-12 md-mb-50px">

                                   <div dangerouslySetInnerHTML={{__html:data?.desc}}></div>

                                </div>

                                {/* <div class="col-lg-6 "><img src="images/demo-decor-store-blog-single-pot.jpg" alt="" /></div> */}

                            </div>

                        </div>

                    </div>

                </div>

            </section>

           

        </>
    )
}
